<div class="header-container fx-layout-row fx-justify-start fx-align-center fx-gap-10">
  @if (assetGroup) {
    <div class="asset-group-name-block page-title">
      <div>{{ assetGroup?.toString() }}</div>
    </div>
  }

  <div class="fx-flex"></div>
  <div id="asset-group-menu" class="fx-layout-row">
    <restricted-icon-button
      icon="mdi-dots-vertical"
      iconClass="sm"
      [id]="'asset-group-sheet-menu-button'"
      [matMenuTriggerFor]="menu"
      [preconditions]="accessManager.hasAccess(Permission.DELETE_ASSET_GROUP)">
    </restricted-icon-button>
    <mat-menu #menu="matMenu">
      <restricted-menu-item (onClick)="deleteAssetGroup()" [id]="'delete-asset-group-menu'"
                            [permissions]="[Permission.DELETE_ASSET_GROUP]"
                            [preconditions]="true">
        {{ 'BUTTON.DELETE_ASSET_GROUP' | translate }}
      </restricted-menu-item>
    </mat-menu>
  </div>
</div>
